import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import AuthDialog from '../components/AuthDialog';
import { PublicBetDetails } from '../components/keno/PublicBetDetails';

export default function SharedBet() {
  const { publicId } = useParams();
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false), [mode, setMode] = useState('login');
  return <><Sidebar onAuth={(value) => { setMode(value); setAuthOpen(true); }} /><main className="page-content" data-testid="shared-bet-page"><PublicBetDetails publicId={publicId} game={{ demo: true }} onClose={() => navigate('/games/plinko')} /></main><AuthDialog open={authOpen} onOpenChange={setAuthOpen} mode={mode} setMode={setMode} /></>;
}